import { RestClient } from '@/api/rest-client'
import { TypeformResponse } from '@/api/model/typeform/typeform-response'

export class TypeformResponseClient extends RestClient<TypeformResponse> {
    collectionName = 'service/typeform/responses'
    parseData = TypeformResponse.fromData

    async get(id: string, fresh: boolean = false): Promise<TypeformResponse> {
        try {
            const cached = this.cache.get(id)
            if (!fresh && cached !== undefined) {
                return cached
            }

            const generation = this.cacheGeneration
            const response = await this.client.get(`${this.basePath}/${this.collectionName}/${id}`, {
                headers: {
                    Accept: 'application/json',
                },
            })
            const data = this.parseData(response.data) as TypeformResponse
            this.remember(id, data, generation)

            return data

        } catch (error) {
            this.handleError(error)
        }
    }
}
